import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ViewLeadPopupComponent } from '../../view-lead-popup/view-lead-popup.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-complete-followup',
  templateUrl: './complete-followup.component.html',
  styleUrls: ['./complete-followup.component.css']
})
export class CompleteFollowupComponent implements OnInit {
  type: any;
  allStaffRecords: any;
  childData:any;
  serviceType: String = ''
  expandedRow: number | null = null;
  expandedIndex: number | null = null;
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    private rsbLookup: RsbLookupModel,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getStaff();
  }
  getStaff(): void {
    this.rsbService.getCompleteFollowup({franchiseId:this.rsbLookup.getLoggedUser().franchiseId}).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }
  addStaff(): void {
  }

  view(leads: any): void {
    this.serviceType = leads?.propType
    const modalRef = this.modalService.open(ViewLeadPopupComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.leadStatus = leads.status
        modalRef.result.then((result) => {
      let payload = {}
      result.status = Number(result.status);
      if (result.status === 2) {
        payload = {
          id: this.rsbLookup.getLoggedUser().franchiseId,
          status: result.status,
          leadId: leads.leadId,
          date: result.date,
          description: result.remarks,
          propType: this.serviceType
        }
        this.rsbService.addFollowup(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.followupRedirectedMethod(result)
          }
        })


      } else {
        payload = {
          leadId: leads.leadId,
          status: result.status
        }
      }
      if (this.serviceType === 'realEstate') {
        this.rsbService.updateLeadStatusForRealEstate(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      } else if (this.serviceType === 'finTech') {
        this.rsbService.updateLeadStatusForFintech(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      } else {
        this.rsbService.updateLeadStatusForPropServices(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      }
    })

  }

  redirectMethod(result: any): void {
    if (result.status == "3") {
      this.router.navigate(['./Not-Interested-Leads']);
    } else if (result.status == "4") {
      this.router.navigate(['./Dead-Leads']);
    } else {
      this.router.navigate(['./Interested-Leads']);
    }
  }

  followupRedirectedMethod(result:any): void {
    const inputDate = new Date(result.date);
    const today = new Date();
  
    // Normalize both dates to remove time components for accurate comparison
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      this.router.navigate(['./CompleteFollowUp']); // Date is in the future
    } else if (inputDate < today) {
      this.router.navigate(['./PendingFollowUp']); // Date is in the past
    } else {
      this.router.navigate(['./TodayFollowUp']); // Date is today
    }
  }

  toggleRow(index: number) {
    const leadId = this.allStaffRecords[index].leadId;
    this.rsbService.getFollowupDetailsOfLead(leadId).subscribe((rsp) => {
      if(rsp.statusCode === 0) {
        this.childData = rsp.contents
        this.expandedIndex = this.expandedIndex === index ? null : index;
      }
    })
    
  }

}


